import { render, staticRenderFns } from "./regiao_administrativa.vue?vue&type=template&id=9a376b00"
import script from "./regiao_administrativa.vue?vue&type=script&lang=js"
export * from "./regiao_administrativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports